export const FEATURE_FLAGS = {
  APPLE_MDM_VARIANT: 'block-web-apple-mdm-variant',
  CAREERS_LANDING_PAGE: 'block-web-careers-landing-page',
  PRIVACY_LINK: 'block-web-privacy-link',
  AUTOMATED_CARDS: 'block-web-automated-cards',
  BRAND_RESKIN: 'block-web-brand-reskin',
  SECONDARY_TAG_PAGES: 'block-web-secondary-tag-pages'
};
